import { render, staticRenderFns } from "./labelMag.vue?vue&type=template&id=aec43800&scoped=true&"
import script from "./labelMag.vue?vue&type=script&lang=js&"
export * from "./labelMag.vue?vue&type=script&lang=js&"
import style0 from "./labelMag.vue?vue&type=style&index=0&id=aec43800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec43800",
  null
  
)

export default component.exports